/* eslint-disable max-len */
import React from "react";
import "react-bootstrap";
import { Link } from "react-router-dom";
import ContactFormStateful from "./ContactFormStateful";

const GOOGLE_DIRECTIONS_URL = "https://www.google.com/maps/dir/?api=1&destination=Wypoczynkowa%2043%2C%2062-081%20Baranowo";
const BANK_ACCOUNT_NUMBER = "36 1140 2004 0000 3502 8025 8272";

export const copyTextToClipboard = (text) => {
  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard.writeText(text);
    return;
  }

  const textArea = document.createElement("textarea");
  textArea.value = text;
  textArea.setAttribute("readonly", "");
  textArea.style.position = "fixed";
  textArea.style.left = "-9999px";
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    if (document.execCommand) {
      document.execCommand("copy");
    }
  } finally {
    document.body.removeChild(textArea);
  }
};

const ContactPage = () => (
  <div className="contact-page">
    <div className="row p-0 m-0 d-flex justify-content-center align-items-start">
      <div className="col-lg-5">
        <div className="contact-left-column pr-4 pl-4">
          <section className="contact-card">
            <h3 className="contact-card-title">Kontakt</h3>
            <p>
              <i className="contact-icon fas fa-map-marker-alt"></i>
              Wypoczynkowa 43, 62-081 Baranowo
            </p>
            <p>
              <i className="contact-icon fas fa-phone"></i>
              (+48) 575 400 141
            </p>
            <p>
              <i className="contact-icon fas fa-envelope"></i>
              szkola@extra-english.pl
            </p>
            <p>
              <i className="contact-icon fas fa-clock"></i>
              Otwarte od 8:00 do 20:00 pn.-pt.
            </p>
          </section>

          <section className="contact-card">
            <h3 className="contact-card-title">Napisz do nas</h3>
            <p>Zostaw wiadomość. Zawsze chętnie odpowiemy.</p>
            <ContactFormStateful compact hideIntro />
          </section>

          <div className="contact-social-links">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.facebook.com/share/TcCBGmP6aFdLywZj/?mibextid=LQQJ4d"
              className="contact-social-link"
            >
              <i className="fab fa-facebook-f"></i>
              Facebook
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.instagram.com/extra_english.pl/"
              className="contact-social-link"
            >
              <i className="fab fa-instagram"></i>
              Instagram
            </a>
          </div>
        </div>
      </div>

      <div className="col-lg-5">
        <div className="contact-cards pr-4 pl-4 pl-lg-0">
          <section className="contact-card">
            <h3 className="contact-card-title">Dane firmy</h3>
            <p>
              <i className="contact-icon fas fa-building"></i>
              NIP: 777-255-43-86
            </p>
            <p>
              <i className="contact-icon fas fa-building"></i>
              REGON: 300953920
            </p>
            <div className="bank-account-row">
              <span>Konto bankowe</span>
              <div className="bank-account-box">
                <strong>{BANK_ACCOUNT_NUMBER}</strong>
                <button type="button" onClick={() => copyTextToClipboard(BANK_ACCOUNT_NUMBER)}>
                  Skopiuj
                </button>
              </div>
            </div>
            <small>
              *UWAGA w tytule przelewu prosimy wpisać imię i nazwisko dziecka,
              nazwę grupy oraz termin zajęć.
            </small>
          </section>

          <section className="contact-card">
            <h3 className="contact-card-title">Płatności online</h3>
            <div className="payment-card-intro">
              <i className="contact-icon far fa-credit-card"></i>
              <p>
                Płatności online obsługuje Autopay S.A. Dostępne metody mogą
                obejmować szybki przelew, BLIK oraz płatność kartą.
              </p>
            </div>
            <div className="payment-methods">
              <span>Visa</span>
              <span>Visa Electron</span>
              <span>Mastercard</span>
              <span>Mastercard Electronic</span>
              <span>Maestro</span>
            </div>
            <small>Extra English nie przechowuje danych kart płatniczych.</small>
          </section>

          <section className="contact-card">
            <h3 className="contact-card-title">Dokumenty</h3>
            <p>
              Zasady płatności, reklamacji, rezygnacji i zwrotów opisuje{" "}
              <Link to="/regulamin">Regulamin świadczenia usług</Link>.
            </p>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="../../resources/offer/umowa_o_nauke_angielskiego_2025.pdf"
              className="contact-document-link"
            >
              <i className="far fa-file-alt"></i>
              <span>
                Umowa o świadczenie usług
                <small>Pobierz PDF</small>
              </span>
            </a>
          </section>
        </div>
      </div>
    </div>

    <div className="row p-0 m-0 d-flex justify-content-center">
      <div className="col-lg-10">
        <div className="contact-map-section pr-4 pl-4">
          <div className="contact-map-heading">
            <h3 className="contact-card-title">Znajdź nas</h3>
          </div>
          <div className="contact-map google-maps embed-responsive embed-responsive-16by9">
            <iframe
              title="google-maps"
              className="embed-responsive-item"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2432.243909418292!2d16.792514416121623!3d52.438496250018154!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4704476481f3f1b9%3A0x1b85fc0a2ae42062!2sExtra+English!5e0!3m2!1sen!2suk!4v1566327647470!5m2!1sen!2suk"
              frameBorder="0"
            />
          </div>
          <div className="contact-map-footer">
            <span>
              <i className="contact-icon fas fa-map-marker-alt"></i>
              Extra English, Wypoczynkowa 43, 62-081 Baranowo
            </span>
            <a target="_blank" rel="noopener noreferrer" href={GOOGLE_DIRECTIONS_URL}>
              <i className="contact-icon fas fa-location-arrow"></i>
              Wyznacz trasę
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default ContactPage;
